import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ITaskTypeCol } from "ui/Scripts/source/models/task/taskTypeCol";
import { IdTitleDropdown, IIdTitleDropdownItem } from "ui/Scripts/source/components/framework/Dropdown/IdTitleDropdown";
import { Translations } from "ui/Scripts/source/models/translations";
import { Base } from "ui/Scripts/source/framework/base";
import { getTaskFormDesignerComponentTitle, getTaskFormDesignerComponentType, TaskFormDesignerComponentType } from "../FormDesignerComponentPicker";

interface IFormDesignerComponentPropertiesNameProps {
    headerTypeCol: ITaskTypeCol;
    formTypeCol: ITaskTypeCol;
    headerCols: ITaskTypeCol[];
    formCols: ITaskTypeCol[];
    onHeaderItemClick: (field: string) => void;
    onFormItemClick: (field: string) => void;
}

//TODO: Check custom width classes handling
export const FormDesignerComponentPropertiesName = (props: IFormDesignerComponentPropertiesNameProps) => {
    const hederPrefix = "H";
    const formPrefix = "F";
    const [dropdownItems, setDropdownItems] = useState<IIdTitleDropdownItem[]>([]);

    const getFieldId = (col: ITaskTypeCol, prefix: string) => {
        return `${prefix}#${col.field}`;
    };

    const getHeaderFieldId = (col: ITaskTypeCol) => {
        return getFieldId(col, hederPrefix);
    };

    const getFormFieldId = (col: ITaskTypeCol) => {
        return getFieldId(col, formPrefix);
    };

    const removeHtmlTags = (html: string): string => {
        try {
            const tmp = document.createElement("div");
            tmp.innerHTML = html;
            return tmp.textContent || tmp.innerText || "";
        } catch {
            return "";
        }
    };

    const getDropDownTitle = (col: ITaskTypeCol) => {
        const designerComponentType = getTaskFormDesignerComponentType(col);
        let title = designerComponentType === TaskFormDesignerComponentType.LineBreak ||
            designerComponentType === TaskFormDesignerComponentType.EmptyArea
            ? null
            : (!col.title
                ? ""
                : (designerComponentType === TaskFormDesignerComponentType.RichText
                    ? removeHtmlTags(col.title)
                    : col.title));
        if (title?.length > 20) {
            title = title.substring(0, 20).trim() + "...";
        }
        const titleStr = title ? ` (${title})` : "";
        return `${getTaskFormDesignerComponentTitle(col)}${titleStr}`;
    };

    useEffect(() => {
        const newDropdownItems: IIdTitleDropdownItem[] = [];
        if (props.headerCols && props.headerCols.length) {
            newDropdownItems.push({ id: Base.getGuid(), title: Translations.Header, unselectable: true });
            newDropdownItems.push({ id: Base.getGuid(), title: "", divider: true });
            props.headerCols.forEach((col) => {
                newDropdownItems.push({
                    id: getHeaderFieldId(col),
                    title: getDropDownTitle(col)
                });
            });
        }
        newDropdownItems.push({ id: Base.getGuid(), title: Translations.Contents, unselectable: true });
        newDropdownItems.push({ id: Base.getGuid(), title: "", divider: true });
        props.formCols.forEach((col) => {
            newDropdownItems.push({
                id: getFormFieldId(col),
                title: getDropDownTitle(col)
            });
        });
        setDropdownItems(newDropdownItems);
    }, [props.headerCols, props.formCols]);

    if (!(props.headerTypeCol ?? props.formTypeCol)) return null;
    
    return (
        <Box sx={{ paddingLeft: "16px", paddingRight: "16px", paddingBottom: "8px", fontSize: "14px" }}>
            <IdTitleDropdown
                selectedId={props.headerTypeCol ? getHeaderFieldId(props.headerTypeCol) : getFormFieldId(props.formTypeCol)}
                items={dropdownItems}
                onChange={(id) => {
                    const field = id.substring(2);
                    if (id.startsWith(hederPrefix)) {
                        props.onHeaderItemClick(field);
                    } else {
                        props.onFormItemClick(field);
                    }
                }}
            />
        </Box>
    );
};
